"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessInfoRoutes = void 0;
const compliance_route_1 = require("./compliance-route");
class BusinessInfoRoutes extends compliance_route_1.ComplianceRoute {
    constructor() {
        super('business_info');
    }
    create(params) {
        return this.post('/create', params);
    }
    update(params) {
        return this.post('/update', params);
    }
    getCurrentBusiness() {
        return this.get('/current');
    }
    updateCurrentBusinessStatus(status) {
        return this.post('/current/status', { status });
    }
}
exports.BusinessInfoRoutes = BusinessInfoRoutes;
//# sourceMappingURL=business_info.js.map